export default __webpack_public_path__ + "static/media/logo.6a2b2982.svg";